import "./App.css";

function App() {
  return (<div className="mx-auto md:w-4/5 w-full">
    <h2 className="text-3xl font-bold text-center">
      Z Tech & IT Solutions
    </h2>
    <p className="text-center">
      Welcome to Z Tech & IT Solutions. We are a team of professionals who are
      dedicated to providing the best IT solutions to our clients. We are
      committed to providing the best services to our clients.
    </p>
    <div>
      <ul className="flex flex-col mx-auto items-center">
        <li className="p-3 my-2 rounded bg-pink-400">Computer Repair</li>
        <li className="p-3 my-2 rounded bg-orange-400">Laptop Repair</li>
        <li className="p-3 my-2 rounded bg-red-400">Mobile App Development</li>
        <li className="p-3 my-2 rounded bg-green-400">Website Development</li>
      </ul>
    </div>
    <iframe title="google-form" src="https://docs.google.com/forms/d/e/1FAIpQLSfAHTY-pKrRTmHBvCrbAbH7-5Om4eY82K6u4ljM14d6twu6Zg/viewform?embedded=true" className="mx-auto w-4/5" height="1760" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
  </div>);
}

export default App;
